/**
 * GENERATED by W3-01 (src/ui/iconSet.test.ts explains how to refresh it): the lucide icons the app names in its
 * source, imported one by one so the bundle carries only these (UX-006; the whole set is about 750 KB). Icon.tsx
 * loads the full set on demand for a name that is not listed here (a new icon renders after a moment and the dev
 * build says which file to refresh).
 */

import type { LucideIcon } from 'lucide-react';
import {
  Activity as IconActivity,
  AlignHorizontalSpaceAround as IconAlignHorizontalSpaceAround,
  Anchor as IconAnchor,
  AppWindow as IconAppWindow,
  Archive as IconArchive,
  ArchiveRestore as IconArchiveRestore,
  ArrowBigUp as IconArrowBigUp,
  ArrowDown as IconArrowDown,
  ArrowDownAZ as IconArrowDownAZ,
  ArrowDownFromLine as IconArrowDownFromLine,
  ArrowDownToLine as IconArrowDownToLine,
  ArrowDownUp as IconArrowDownUp,
  ArrowLeft as IconArrowLeft,
  ArrowLeftRight as IconArrowLeftRight,
  ArrowRight as IconArrowRight,
  ArrowRightFromLine as IconArrowRightFromLine,
  ArrowRightLeft as IconArrowRightLeft,
  ArrowRightToLine as IconArrowRightToLine,
  ArrowUp as IconArrowUp,
  ArrowUpDown as IconArrowUpDown,
  ArrowUpFromLine as IconArrowUpFromLine,
  ArrowUpToLine as IconArrowUpToLine,
  AudioLines as IconAudioLines,
  AudioWaveform as IconAudioWaveform,
  Award as IconAward,
  Badge as IconBadge,
  BadgeCheck as IconBadgeCheck,
  Ban as IconBan,
  BetweenHorizontalEnd as IconBetweenHorizontalEnd,
  BetweenHorizontalStart as IconBetweenHorizontalStart,
  Blocks as IconBlocks,
  BookOpen as IconBookOpen,
  Bookmark as IconBookmark,
  BookmarkPlus as IconBookmarkPlus,
  BookmarkX as IconBookmarkX,
  Braces as IconBraces,
  BringToFront as IconBringToFront,
  Brush as IconBrush,
  ChartNoAxesColumnIncreasing as IconChartNoAxesColumnIncreasing,
  ChartSpline as IconChartSpline,
  Check as IconCheck,
  ChevronDown as IconChevronDown,
  ChevronLeft as IconChevronLeft,
  ChevronRight as IconChevronRight,
  ChevronUp as IconChevronUp,
  ChevronsDown as IconChevronsDown,
  ChevronsDownUp as IconChevronsDownUp,
  ChevronsRight as IconChevronsRight,
  ChevronsUp as IconChevronsUp,
  ChevronsUpDown as IconChevronsUpDown,
  Circle as IconCircle,
  CircleAlert as IconCircleAlert,
  CircleCheck as IconCircleCheck,
  CircleDashed as IconCircleDashed,
  CircleDot as IconCircleDot,
  CirclePause as IconCirclePause,
  CircleQuestionMark as IconCircleQuestionMark,
  CircleSlash as IconCircleSlash,
  CircleStop as IconCircleStop,
  CircleX as IconCircleX,
  ClipboardCheck as IconClipboardCheck,
  ClipboardCopy as IconClipboardCopy,
  ClipboardList as IconClipboardList,
  ClipboardPaste as IconClipboardPaste,
  Clock as IconClock,
  CloudAlert as IconCloudAlert,
  CloudCheck as IconCloudCheck,
  CloudOff as IconCloudOff,
  CloudUpload as IconCloudUpload,
  Columns3 as IconColumns3,
  Columns4 as IconColumns4,
  Command as IconCommand,
  Compass as IconCompass,
  Contrast as IconContrast,
  Copy as IconCopy,
  CopyMinus as IconCopyMinus,
  CopyPlus as IconCopyPlus,
  CornerDownLeft as IconCornerDownLeft,
  CornerDownRight as IconCornerDownRight,
  Crosshair as IconCrosshair,
  Database as IconDatabase,
  Delete as IconDelete,
  Diamond as IconDiamond,
  DiamondPlus as IconDiamondPlus,
  Dices as IconDices,
  Divide as IconDivide,
  Download as IconDownload,
  Drum as IconDrum,
  Ear as IconEar,
  Ellipsis as IconEllipsis,
  EllipsisVertical as IconEllipsisVertical,
  Equal as IconEqual,
  Eraser as IconEraser,
  Expand as IconExpand,
  ExternalLink as IconExternalLink,
  Eye as IconEye,
  EyeOff as IconEyeOff,
  FastForward as IconFastForward,
  File as IconFile,
  FileClock as IconFileClock,
  FileCode as IconFileCode,
  FileDown as IconFileDown,
  FileExclamationPoint as IconFileExclamationPoint,
  FileHeadphone as IconFileHeadphone,
  FileImage as IconFileImage,
  FileInput as IconFileInput,
  FileMusic as IconFileMusic,
  FilePen as IconFilePen,
  FilePlay as IconFilePlay,
  FilePlusCorner as IconFilePlusCorner,
  FileQuestionMark as IconFileQuestionMark,
  FileText as IconFileText,
  FileType as IconFileType,
  FileUp as IconFileUp,
  FileX as IconFileX,
  Files as IconFiles,
  Film as IconFilm,
  Flag as IconFlag,
  Focus as IconFocus,
  FolderInput as IconFolderInput,
  FolderOpen as IconFolderOpen,
  FolderPlus as IconFolderPlus,
  FolderUp as IconFolderUp,
  Footprints as IconFootprints,
  Funnel as IconFunnel,
  FunnelX as IconFunnelX,
  GalleryHorizontalEnd as IconGalleryHorizontalEnd,
  Gamepad2 as IconGamepad2,
  Gauge as IconGauge,
  Ghost as IconGhost,
  GitCompareArrows as IconGitCompareArrows,
  GraduationCap as IconGraduationCap,
  Grid3x3 as IconGrid3x3,
  Group as IconGroup,
  Hand as IconHand,
  HardDrive as IconHardDrive,
  HardDriveDownload as IconHardDriveDownload,
  Hash as IconHash,
  Headphones as IconHeadphones,
  HeartPulse as IconHeartPulse,
  House as IconHouse,
  Image as IconImage,
  ImageDown as IconImageDown,
  ImageOff as IconImageOff,
  ImagePlus as IconImagePlus,
  ImageUp as IconImageUp,
  Infinity as IconInfinity,
  Info as IconInfo,
  Key as IconKey,
  KeyRound as IconKeyRound,
  Keyboard as IconKeyboard,
  Languages as IconLanguages,
  Laptop as IconLaptop,
  Layers as IconLayers,
  LayoutDashboard as IconLayoutDashboard,
  LayoutGrid as IconLayoutGrid,
  LayoutPanelTop as IconLayoutPanelTop,
  LayoutTemplate as IconLayoutTemplate,
  Library as IconLibrary,
  LibraryBig as IconLibraryBig,
  LifeBuoy as IconLifeBuoy,
  Lightbulb as IconLightbulb,
  Link as IconLink,
  Link2 as IconLink2,
  List as IconList,
  ListChecks as IconListChecks,
  ListFilter as IconListFilter,
  ListOrdered as IconListOrdered,
  ListPlus as IconListPlus,
  ListRestart as IconListRestart,
  ListTree as IconListTree,
  ListX as IconListX,
  LoaderCircle as IconLoaderCircle,
  LocateFixed as IconLocateFixed,
  Lock as IconLock,
  LockOpen as IconLockOpen,
  Magnet as IconMagnet,
  Map as IconMap,
  MapPin as IconMapPin,
  MapPinOff as IconMapPinOff,
  Maximize as IconMaximize,
  Maximize2 as IconMaximize2,
  Menu as IconMenu,
  Merge as IconMerge,
  MessageSquareText as IconMessageSquareText,
  Metronome as IconMetronome,
  Minimize as IconMinimize,
  Minimize2 as IconMinimize2,
  Minus as IconMinus,
  MonitorPlay as IconMonitorPlay,
  MonitorSmartphone as IconMonitorSmartphone,
  Moon as IconMoon,
  Mouse as IconMouse,
  MousePointer2 as IconMousePointer2,
  MousePointerClick as IconMousePointerClick,
  Move as IconMove,
  MoveHorizontal as IconMoveHorizontal,
  MoveRight as IconMoveRight,
  MoveVertical as IconMoveVertical,
  Music as IconMusic,
  Music2 as IconMusic2,
  Music4 as IconMusic4,
  Network as IconNetwork,
  OctagonAlert as IconOctagonAlert,
  OctagonX as IconOctagonX,
  Option as IconOption,
  Orbit as IconOrbit,
  Package as IconPackage,
  PackageCheck as IconPackageCheck,
  PackageOpen as IconPackageOpen,
  Palette as IconPalette,
  PanelBottom as IconPanelBottom,
  PanelRight as IconPanelRight,
  PanelsTopLeft as IconPanelsTopLeft,
  Pause as IconPause,
  PenLine as IconPenLine,
  PenTool as IconPenTool,
  Pencil as IconPencil,
  PencilLine as IconPencilLine,
  Pi as IconPi,
  PictureInPicture2 as IconPictureInPicture2,
  Pin as IconPin,
  PinOff as IconPinOff,
  Pipette as IconPipette,
  Play as IconPlay,
  Plus as IconPlus,
  Printer as IconPrinter,
  Quote as IconQuote,
  Radius as IconRadius,
  Rat as IconRat,
  RectangleHorizontal as IconRectangleHorizontal,
  RectangleVertical as IconRectangleVertical,
  Redo as IconRedo,
  Redo2 as IconRedo2,
  RefreshCw as IconRefreshCw,
  Repeat as IconRepeat,
  Repeat2 as IconRepeat2,
  Replace as IconReplace,
  Rewind as IconRewind,
  RotateCcw as IconRotateCcw,
  RotateCcwClock as IconRotateCcwClock,
  RotateCw as IconRotateCw,
  Route as IconRoute,
  Rows2 as IconRows2,
  Rows3 as IconRows3,
  Rows4 as IconRows4,
  Ruler as IconRuler,
  Save as IconSave,
  Scaling as IconScaling,
  Scan as IconScan,
  ScanEye as IconScanEye,
  ScanSearch as IconScanSearch,
  Scissors as IconScissors,
  Search as IconSearch,
  SearchX as IconSearchX,
  Section as IconSection,
  SendToBack as IconSendToBack,
  Settings as IconSettings,
  Settings2 as IconSettings2,
  Shapes as IconShapes,
  Sheet as IconSheet,
  Shell as IconShell,
  ShieldAlert as IconShieldAlert,
  ShieldCheck as IconShieldCheck,
  Shrink as IconShrink,
  Sigma as IconSigma,
  Signal as IconSignal,
  SkipBack as IconSkipBack,
  SkipForward as IconSkipForward,
  Slash as IconSlash,
  SlidersHorizontal as IconSlidersHorizontal,
  Smartphone as IconSmartphone,
  Space as IconSpace,
  Sparkles as IconSparkles,
  Spline as IconSpline,
  Square as IconSquare,
  SquareArrowLeft as IconSquareArrowLeft,
  SquareCenterlineDashedHorizontal as IconSquareCenterlineDashedHorizontal,
  SquareCheck as IconSquareCheck,
  SquareDashed as IconSquareDashed,
  SquareDashedMousePointer as IconSquareDashedMousePointer,
  SquarePen as IconSquarePen,
  SquareSplitVertical as IconSquareSplitVertical,
  Star as IconStar,
  StarOff as IconStarOff,
  StepForward as IconStepForward,
  Sun as IconSun,
  SunMoon as IconSunMoon,
  Table as IconTable,
  Tag as IconTag,
  Tags as IconTags,
  Tally5 as IconTally5,
  Target as IconTarget,
  TextAlignStart as IconTextAlignStart,
  TextCursorInput as IconTextCursorInput,
  TextSearch as IconTextSearch,
  TextWrap as IconTextWrap,
  Theater as IconTheater,
  Timeline as IconTimeline,
  Timer as IconTimer,
  Trash as IconTrash,
  TrendingUp as IconTrendingUp,
  TriangleAlert as IconTriangleAlert,
  TrianglesCenterlineDashedHorizontal as IconTrianglesCenterlineDashedHorizontal,
  TrianglesCenterlineDashedVertical as IconTrianglesCenterlineDashedVertical,
  Trophy as IconTrophy,
  Type as IconType,
  Undo as IconUndo,
  Undo2 as IconUndo2,
  Unlink as IconUnlink,
  Upload as IconUpload,
  UserPen as IconUserPen,
  Vibrate as IconVibrate,
  Video as IconVideo,
  View as IconView,
  Volume as IconVolume,
  Volume2 as IconVolume2,
  VolumeX as IconVolumeX,
  Wand as IconWand,
  WandSparkles as IconWandSparkles,
  Watch as IconWatch,
  WavesHorizontal as IconWavesHorizontal,
  Wrench as IconWrench,
  Zap as IconZap,
  ZoomIn as IconZoomIn,
  ZoomOut as IconZoomOut,
} from 'lucide-react';

export const ICON_SET: Readonly<Record<string, LucideIcon>> = {
  Activity: IconActivity,
  AlignHorizontalSpaceAround: IconAlignHorizontalSpaceAround,
  Anchor: IconAnchor,
  AppWindow: IconAppWindow,
  Archive: IconArchive,
  ArchiveRestore: IconArchiveRestore,
  ArrowBigUp: IconArrowBigUp,
  ArrowDown: IconArrowDown,
  ArrowDownAZ: IconArrowDownAZ,
  ArrowDownFromLine: IconArrowDownFromLine,
  ArrowDownToLine: IconArrowDownToLine,
  ArrowDownUp: IconArrowDownUp,
  ArrowLeft: IconArrowLeft,
  ArrowLeftRight: IconArrowLeftRight,
  ArrowRight: IconArrowRight,
  ArrowRightFromLine: IconArrowRightFromLine,
  ArrowRightLeft: IconArrowRightLeft,
  ArrowRightToLine: IconArrowRightToLine,
  ArrowUp: IconArrowUp,
  ArrowUpDown: IconArrowUpDown,
  ArrowUpFromLine: IconArrowUpFromLine,
  ArrowUpToLine: IconArrowUpToLine,
  AudioLines: IconAudioLines,
  AudioWaveform: IconAudioWaveform,
  Award: IconAward,
  Badge: IconBadge,
  BadgeCheck: IconBadgeCheck,
  Ban: IconBan,
  BetweenHorizontalEnd: IconBetweenHorizontalEnd,
  BetweenHorizontalStart: IconBetweenHorizontalStart,
  Blocks: IconBlocks,
  BookOpen: IconBookOpen,
  Bookmark: IconBookmark,
  BookmarkPlus: IconBookmarkPlus,
  BookmarkX: IconBookmarkX,
  Braces: IconBraces,
  BringToFront: IconBringToFront,
  Brush: IconBrush,
  ChartNoAxesColumnIncreasing: IconChartNoAxesColumnIncreasing,
  ChartSpline: IconChartSpline,
  Check: IconCheck,
  ChevronDown: IconChevronDown,
  ChevronLeft: IconChevronLeft,
  ChevronRight: IconChevronRight,
  ChevronUp: IconChevronUp,
  ChevronsDown: IconChevronsDown,
  ChevronsDownUp: IconChevronsDownUp,
  ChevronsRight: IconChevronsRight,
  ChevronsUp: IconChevronsUp,
  ChevronsUpDown: IconChevronsUpDown,
  Circle: IconCircle,
  CircleAlert: IconCircleAlert,
  CircleCheck: IconCircleCheck,
  CircleDashed: IconCircleDashed,
  CircleDot: IconCircleDot,
  CirclePause: IconCirclePause,
  CircleQuestionMark: IconCircleQuestionMark,
  CircleSlash: IconCircleSlash,
  CircleStop: IconCircleStop,
  CircleX: IconCircleX,
  ClipboardCheck: IconClipboardCheck,
  ClipboardCopy: IconClipboardCopy,
  ClipboardList: IconClipboardList,
  ClipboardPaste: IconClipboardPaste,
  Clock: IconClock,
  CloudAlert: IconCloudAlert,
  CloudCheck: IconCloudCheck,
  CloudOff: IconCloudOff,
  CloudUpload: IconCloudUpload,
  Columns3: IconColumns3,
  Columns4: IconColumns4,
  Command: IconCommand,
  Compass: IconCompass,
  Contrast: IconContrast,
  Copy: IconCopy,
  CopyMinus: IconCopyMinus,
  CopyPlus: IconCopyPlus,
  CornerDownLeft: IconCornerDownLeft,
  CornerDownRight: IconCornerDownRight,
  Crosshair: IconCrosshair,
  Database: IconDatabase,
  Delete: IconDelete,
  Diamond: IconDiamond,
  DiamondPlus: IconDiamondPlus,
  Dices: IconDices,
  Divide: IconDivide,
  Download: IconDownload,
  Drum: IconDrum,
  Ear: IconEar,
  Ellipsis: IconEllipsis,
  EllipsisVertical: IconEllipsisVertical,
  Equal: IconEqual,
  Eraser: IconEraser,
  Expand: IconExpand,
  ExternalLink: IconExternalLink,
  Eye: IconEye,
  EyeOff: IconEyeOff,
  FastForward: IconFastForward,
  File: IconFile,
  FileClock: IconFileClock,
  FileCode: IconFileCode,
  FileDown: IconFileDown,
  FileExclamationPoint: IconFileExclamationPoint,
  FileHeadphone: IconFileHeadphone,
  FileImage: IconFileImage,
  FileInput: IconFileInput,
  FileMusic: IconFileMusic,
  FilePen: IconFilePen,
  FilePlay: IconFilePlay,
  FilePlusCorner: IconFilePlusCorner,
  FileQuestionMark: IconFileQuestionMark,
  FileText: IconFileText,
  FileType: IconFileType,
  FileUp: IconFileUp,
  FileX: IconFileX,
  Files: IconFiles,
  Film: IconFilm,
  Flag: IconFlag,
  Focus: IconFocus,
  FolderInput: IconFolderInput,
  FolderOpen: IconFolderOpen,
  FolderPlus: IconFolderPlus,
  FolderUp: IconFolderUp,
  Footprints: IconFootprints,
  Funnel: IconFunnel,
  FunnelX: IconFunnelX,
  GalleryHorizontalEnd: IconGalleryHorizontalEnd,
  Gamepad2: IconGamepad2,
  Gauge: IconGauge,
  Ghost: IconGhost,
  GitCompareArrows: IconGitCompareArrows,
  GraduationCap: IconGraduationCap,
  Grid3x3: IconGrid3x3,
  Group: IconGroup,
  Hand: IconHand,
  HardDrive: IconHardDrive,
  HardDriveDownload: IconHardDriveDownload,
  Hash: IconHash,
  Headphones: IconHeadphones,
  HeartPulse: IconHeartPulse,
  House: IconHouse,
  Image: IconImage,
  ImageDown: IconImageDown,
  ImageOff: IconImageOff,
  ImagePlus: IconImagePlus,
  ImageUp: IconImageUp,
  Infinity: IconInfinity,
  Info: IconInfo,
  Key: IconKey,
  KeyRound: IconKeyRound,
  Keyboard: IconKeyboard,
  Languages: IconLanguages,
  Laptop: IconLaptop,
  Layers: IconLayers,
  LayoutDashboard: IconLayoutDashboard,
  LayoutGrid: IconLayoutGrid,
  LayoutPanelTop: IconLayoutPanelTop,
  LayoutTemplate: IconLayoutTemplate,
  Library: IconLibrary,
  LibraryBig: IconLibraryBig,
  LifeBuoy: IconLifeBuoy,
  Lightbulb: IconLightbulb,
  Link: IconLink,
  Link2: IconLink2,
  List: IconList,
  ListChecks: IconListChecks,
  ListFilter: IconListFilter,
  ListOrdered: IconListOrdered,
  ListPlus: IconListPlus,
  ListRestart: IconListRestart,
  ListTree: IconListTree,
  ListX: IconListX,
  LoaderCircle: IconLoaderCircle,
  LocateFixed: IconLocateFixed,
  Lock: IconLock,
  LockOpen: IconLockOpen,
  Magnet: IconMagnet,
  Map: IconMap,
  MapPin: IconMapPin,
  MapPinOff: IconMapPinOff,
  Maximize: IconMaximize,
  Maximize2: IconMaximize2,
  Menu: IconMenu,
  Merge: IconMerge,
  MessageSquareText: IconMessageSquareText,
  Metronome: IconMetronome,
  Minimize: IconMinimize,
  Minimize2: IconMinimize2,
  Minus: IconMinus,
  MonitorPlay: IconMonitorPlay,
  MonitorSmartphone: IconMonitorSmartphone,
  Moon: IconMoon,
  Mouse: IconMouse,
  MousePointer2: IconMousePointer2,
  MousePointerClick: IconMousePointerClick,
  Move: IconMove,
  MoveHorizontal: IconMoveHorizontal,
  MoveRight: IconMoveRight,
  MoveVertical: IconMoveVertical,
  Music: IconMusic,
  Music2: IconMusic2,
  Music4: IconMusic4,
  Network: IconNetwork,
  OctagonAlert: IconOctagonAlert,
  OctagonX: IconOctagonX,
  Option: IconOption,
  Orbit: IconOrbit,
  Package: IconPackage,
  PackageCheck: IconPackageCheck,
  PackageOpen: IconPackageOpen,
  Palette: IconPalette,
  PanelBottom: IconPanelBottom,
  PanelRight: IconPanelRight,
  PanelsTopLeft: IconPanelsTopLeft,
  Pause: IconPause,
  PenLine: IconPenLine,
  PenTool: IconPenTool,
  Pencil: IconPencil,
  PencilLine: IconPencilLine,
  Pi: IconPi,
  PictureInPicture2: IconPictureInPicture2,
  Pin: IconPin,
  PinOff: IconPinOff,
  Pipette: IconPipette,
  Play: IconPlay,
  Plus: IconPlus,
  Printer: IconPrinter,
  Quote: IconQuote,
  Radius: IconRadius,
  Rat: IconRat,
  RectangleHorizontal: IconRectangleHorizontal,
  RectangleVertical: IconRectangleVertical,
  Redo: IconRedo,
  Redo2: IconRedo2,
  RefreshCw: IconRefreshCw,
  Repeat: IconRepeat,
  Repeat2: IconRepeat2,
  Replace: IconReplace,
  Rewind: IconRewind,
  RotateCcw: IconRotateCcw,
  RotateCcwClock: IconRotateCcwClock,
  RotateCw: IconRotateCw,
  Route: IconRoute,
  Rows2: IconRows2,
  Rows3: IconRows3,
  Rows4: IconRows4,
  Ruler: IconRuler,
  Save: IconSave,
  Scaling: IconScaling,
  Scan: IconScan,
  ScanEye: IconScanEye,
  ScanSearch: IconScanSearch,
  Scissors: IconScissors,
  Search: IconSearch,
  SearchX: IconSearchX,
  Section: IconSection,
  SendToBack: IconSendToBack,
  Settings: IconSettings,
  Settings2: IconSettings2,
  Shapes: IconShapes,
  Sheet: IconSheet,
  Shell: IconShell,
  ShieldAlert: IconShieldAlert,
  ShieldCheck: IconShieldCheck,
  Shrink: IconShrink,
  Sigma: IconSigma,
  Signal: IconSignal,
  SkipBack: IconSkipBack,
  SkipForward: IconSkipForward,
  Slash: IconSlash,
  SlidersHorizontal: IconSlidersHorizontal,
  Smartphone: IconSmartphone,
  Space: IconSpace,
  Sparkles: IconSparkles,
  Spline: IconSpline,
  Square: IconSquare,
  SquareArrowLeft: IconSquareArrowLeft,
  SquareCenterlineDashedHorizontal: IconSquareCenterlineDashedHorizontal,
  SquareCheck: IconSquareCheck,
  SquareDashed: IconSquareDashed,
  SquareDashedMousePointer: IconSquareDashedMousePointer,
  SquarePen: IconSquarePen,
  SquareSplitVertical: IconSquareSplitVertical,
  Star: IconStar,
  StarOff: IconStarOff,
  StepForward: IconStepForward,
  Sun: IconSun,
  SunMoon: IconSunMoon,
  Table: IconTable,
  Tag: IconTag,
  Tags: IconTags,
  Tally5: IconTally5,
  Target: IconTarget,
  TextAlignStart: IconTextAlignStart,
  TextCursorInput: IconTextCursorInput,
  TextSearch: IconTextSearch,
  TextWrap: IconTextWrap,
  Theater: IconTheater,
  Timeline: IconTimeline,
  Timer: IconTimer,
  Trash: IconTrash,
  TrendingUp: IconTrendingUp,
  TriangleAlert: IconTriangleAlert,
  TrianglesCenterlineDashedHorizontal: IconTrianglesCenterlineDashedHorizontal,
  TrianglesCenterlineDashedVertical: IconTrianglesCenterlineDashedVertical,
  Trophy: IconTrophy,
  Type: IconType,
  Undo: IconUndo,
  Undo2: IconUndo2,
  Unlink: IconUnlink,
  Upload: IconUpload,
  UserPen: IconUserPen,
  Vibrate: IconVibrate,
  Video: IconVideo,
  View: IconView,
  Volume: IconVolume,
  Volume2: IconVolume2,
  VolumeX: IconVolumeX,
  Wand: IconWand,
  WandSparkles: IconWandSparkles,
  Watch: IconWatch,
  WavesHorizontal: IconWavesHorizontal,
  Wrench: IconWrench,
  Zap: IconZap,
  ZoomIn: IconZoomIn,
  ZoomOut: IconZoomOut,
};
